"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ramda = require("ramda");
var _Button = _interopRequireWildcard(require("../Button"));
var _minus = _interopRequireDefault(require("./img/minus.svg"));
var _plus = _interopRequireDefault(require("./img/plus.svg"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var Counter = function Counter(_ref) {
  var _ref$buttonProps = _ref.buttonProps,
    buttonProps = _ref$buttonProps === void 0 ? {} : _ref$buttonProps,
    max = _ref.max,
    min = _ref.min,
    _ref$stylesMap = _ref.stylesMap,
    stylesMap = _ref$stylesMap === void 0 ? {} : _ref$stylesMap,
    value = _ref.value,
    onDecrease = _ref.onDecrease,
    onIncrease = _ref.onIncrease;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.root
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_styles.default.control, stylesMap.control)
  }, /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
    circle: true,
    disabled: min === value,
    icon: _minus.default,
    height: _Button.HEIGHTS.FLUID,
    width: _Button.WIDTHS.FLUID,
    size: _Button.SIZES.TINY,
    theme: _Button.THEMES.GRAY,
    onClick: function onClick() {
      if (min !== value) {
        onDecrease((0, _ramda.dec)(value));
      }
    }
  }, buttonProps))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_styles.default.count, stylesMap.count)
  }, value), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_styles.default.control, stylesMap.control)
  }, /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
    circle: true,
    disabled: max === value,
    icon: _plus.default,
    height: _Button.HEIGHTS.FLUID,
    size: _Button.SIZES.TINY,
    theme: _Button.THEMES.GRAY,
    width: _Button.WIDTHS.FLUID,
    onClick: function onClick() {
      if (max !== value) {
        onIncrease((0, _ramda.inc)(value));
      }
    }
  }, buttonProps))));
};
Counter.propTypes = {
  buttonProps: _propTypes.default.object,
  max: _propTypes.default.number.isRequired,
  min: _propTypes.default.number.isRequired,
  stylesMap: _propTypes.default.object,
  value: _propTypes.default.number.isRequired,
  onDecrease: _propTypes.default.func.isRequired,
  onIncrease: _propTypes.default.func.isRequired
};
var _default = exports.default = (0, _react.memo)(Counter);